import Vue from 'vue'
import ElementUI from 'element-ui';
import './styles/element-variables.scss'
import '@/styles/index.scss' // global css

// import './styles/fonts.scss' // 引入字体样式

import App from './App.vue'
import router from './router'
import store from './store'
import emun from './emun'
import './icons' // icon
import './permission' 
import VueQuillEditor from 'vue-quill-editor'
import moment from 'moment'
import * as tools from './utils/util.js'
import InstallCompoenent from './utils/installComponent.js'
// import api from './utils/request'
import api from './utils/api'
import settings from './settings'

// require styles 引入样式
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
Vue.use(VueQuillEditor)
Vue.use(InstallCompoenent) // 自动注册组件
Vue.prototype.$tools = tools // 挂载全局方法
Vue.prototype.$api = api // 挂载全局request
Vue.prototype.$emun = emun
Vue.prototype.$moment = moment
Vue.prototype.$settings = settings

Vue.config.productionTip = false
Vue.use(ElementUI, {
  size: 'small' // set element-ui default size
})

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
